
import { Component, Vue, Prop } from 'vue-property-decorator';
// @ts-ignore
import stores from '@/stores';
import session from '@/stores/Session';
import axiosInstance from '../../helpers/axios';
import WorldClockLocationModule from '../../stores/modules/WorldClockLocation';
import TimeZones from '@/modules/TimeZones.vue';
import { SweetModal } from 'sweet-modal-vue';
import {showToaster} from "@/components/DashboardComposer/helpers";
import {translate} from "@/helpers/functions";

@Component({
  components: {
    TimeZones,
    SweetModal,
  },
})
export default class CreateWorldClockLocation extends Vue {
  @Prop()
  module!: WorldClockLocationModule;

  newWorldClockLocation: IWorldClockLocation = {
    id: null,
    moduelId: this.module.id,
    city: '',
    timeZone: '',
  };

  cityRules = {};
  timezoneRules = {};

  timeZoneSelected(zone: string) {
    if (this.newWorldClockLocation) {
      this.newWorldClockLocation.timeZone = zone;
    }
  }
  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }
  createItem() {
    return this.module.createNewWorldClockLocation(this.newWorldClockLocation)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error.message);
        }
        showToaster('success', '', translate('successfully-created'));

        this.$emit('created', response.data);
        this.clearData();
        this.cancel();
      })
      .catch((e) => {
        showToaster('danger', '', e);
      });
  }
  /**
   * Called when changes need to re-render
   */
  mounted() {
    this.newWorldClockLocation = {
      id: null,
      moduelId: this.module.id,
      city: '',
      timeZone: '',
    };

    this.module.getWorldClockRules()
    .then((response) => {
      const validationRules = response;
      if (validationRules[`city`]) {
        this.cityRules = validationRules[`city`];
      }
      if (validationRules[`time_zone`]) {
        this.timezoneRules = validationRules[`time_zone`];
      }
    });

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const mainForm = document.getElementById('create-clock') as HTMLFormElement;
    const forms = [mainForm];
    // Loop over them and prevent submission
    const validation = Array.prototype.filter.call(forms, (form) => {
      form.addEventListener('submit', (event: any) => {
        event.preventDefault();
        if (form.checkValidity() === true) {
          event.stopPropagation();
          this.createItem();
        }
        if (form.checkValidity() === false) {
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }

  clearData() {
    this.newWorldClockLocation.city= '';
    this.newWorldClockLocation.timeZone = '';
    const form = document.getElementById('create-clock');
    if (form) {
      form.classList.remove('was-validated');
    }
  }
}
